import api from "../../../api/frontend-api";

// initial state
const state = () => ({
	team: []
})

// getters
const getters = {
	searchTeam: (state) => (value) => {
		const searchValue = value.toString().toLowerCase();
		function deepSearch(item){
			return Object.keys(item).some(obj => {
				if(item[obj] && obj !== 'imgId' && obj !== 'id' && obj !== 'position'){
					return typeof item[obj] === 'object' ? deepSearch(item[obj]) : item[obj].toString().toLowerCase().includes(searchValue);
				}
			})
		}
		const searchResult = state.team.filter(item => {
			return deepSearch(item);
		})
		return searchResult;
	}
}

// actions
const actions = {
	getTeam({commit}){
		return new Promise((resolve,reject) => {
			api.getTeam().then(response => {
				commit('SET_TEAM', response.data)
				resolve({'success':response.data});
			}).catch(error => {
				const errorResponse = error && error.response && error.response.data;
				resolve({'errors':errorResponse && errorResponse.message});
			})
		})
	}
}

// mutations
const mutations = {
	SET_TEAM(state, team){
		state.team = team;
	}
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}